import { useAtomValue, useSetAtom } from 'jotai';

import {
  currentMerchantAccountAtom,
  fetchCurrentMerchantAccountAtom,
} from 'data/merchant/atoms/currentMerchantAccountAtom';
import { getOptional, map } from 'utils/remote';

export function useCurrentMerchantAccount() {
  return useAtomValue(currentMerchantAccountAtom);
}

export function useFetchMerchantAccount() {
  return useSetAtom(fetchCurrentMerchantAccountAtom);
}

export function useCurrentMerchantRole() {
  const remote = useCurrentMerchantAccount();

  return map(remote, ({ role }) => role);
}

export function useIsAdmin() {
  const role = useCurrentMerchantRole();

  return ['OWNER'].includes(getOptional(role) ?? 'SUPPORT');
}
